import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import CountUp from 'react-countup';
import IconToggleButton from 'components/common/IconToggleButton';
import { Card, Collapse, Form, InputGroup } from 'react-bootstrap';
import { currency, noCurrency, percent } from 'helpers/utils';
import { toast } from 'react-toastify';

const Discounts = ({ discounts }) => {
 return (
  <Flex alignItems="center" className="border rounded bg-soft-secondary">
   {discounts.map(({ maxQuota, rate, discount, apply, isApply }, index) => {
    //  const aply = apply == 1 ? 'separacion' : apply == 2 ? 'inicial' : apply == 3 ? 'financiacion' : apply == 4 ? 'total' : 'nada';
    const aply = { 0: 'nada', 1: 'separacion', 2: 'inicial', 3: 'financiacion', 4: 'total' }[apply ?? 0];
    return (
     <div key={index} className="p-1 me-3 border-bottom border-200">
      <div className="position-relative ps-3">
       <div className={`position-absolute h-100 start-0 rounded bg-primary`} style={{ width: '4px' }} />
       <Flex alignItems="center">
        <Flex className="fs--2 m-0 me-1">
         <div className="flex-1 position-relative">
          <h5 className="mt-2 text-primary fs-0">Cancela</h5>
          <span className="position-absolute top-50 start-0">en {maxQuota} cts max</span>
         </div>
         <CountUp start={0} end={rate * 100} duration={1} className="text-700 fs-3" suffix="%" separator="," />
        </Flex>
        &
        <Flex className="fs--2 m-0 ms-1">
         <div className="flex-1 position-relative">
          <h5 className="mt-2 text-primary fs-0">Obten</h5>
          <span className="position-absolute top-50 start-0">hasta un</span>
         </div>
         <CountUp start={0} end={discount * 100} duration={1} className="text-700 fs-3" suffix="%" separator="," />
         <div className="position-relative ms-1">
          <h6 className="text-700 mt-2 fs-0">Dto.</h6>
          <span className="position-absolute top-50 start-0">/{aply}</span>
          {isApply && (
           <FontAwesomeIcon
            icon="check-circle"
            className="text-success position-absolute top-0 start-100 translate-middle-x fs-0 ms-1"
           />
          )}
         </div>
        </Flex>
       </Flex>
      </div>
     </div>
    );
   })}
  </Flex>
 );
};
const Quote = () => {
 return (
  <div className="alert alert-warning mb-0 p-2">
   <h6 className="alert-heading text-danger mb-1">¡Advertencia!</h6>
   <p className="mb-0 fs--2">
    Ten en cuenta que la Cotización de orden generada NO es equivalente a una orden efectiva sino se limita a caracter informativo
    para el cliente al quien es enviada por correo electrónico o WhatsApp para la toma de decisiones. y copia de esta al vendedor
    para el debido seguimiento.
   </p>
  </div>
 );
};
const Proposal = () => {
 return (
  <div className="alert alert-warning mb-0 p-2">
   <h6 className="alert-heading text-danger mb-1">¡Advertencia!</h6>
   <p className="mb-0 fs--2">
    Ten en cuenta que la propuesta de orden generada NO es equivalente a una orden efectiva hasta que haya sido revisada y
    aprobada por nuestro equipo administrativo. La propuesta debe ser enviada para su revisión y, una vez aprobada, te
    notificaremos por correo electrónico o WhatsApp.
   </p>
  </div>
 );
};

const Additional = ({ watch, setValue, discounts }) => {
 const [open, setOpen] = useState(false);
 const [apply, setApply] = useState(false);
 const [deductions, setDeductions] = useState({ dto: 0, dtoFormat: '0 %', saving: 0, apply: 0 });

 const Deductions = ({ target: { value, name } }) => {
  const { minInitialPay, iniVal, fncVal, totals } = watch('defaultValues');
  const apply = name === 'apply' ? value : deductions.apply;
  const amount = apply == 1 ? minInitialPay : apply == 2 ? iniVal : apply == 3 ? fncVal : apply == 4 ? totals : 0;
  const chekDiscounts = apply < 1 ? [0] : discounts.filter(e => e.isApply && e.apply == apply);
  const maxDto = Math.max(...chekDiscounts.map(e => e.discount));
  setValue('apply', apply);

  if (name === 'saving') {
   const [dto, dtoFormat] = percent((noCurrency(value) / amount) * 100);

   if (dto > maxDto && watch('notAdmin')) {
    const saving = currency(amount * maxDto, true);
    toast.info(
     `No es posible exceder el ${maxDto * 100 + '%'}de descuento maximo establecido en ${
      apply == 1 ? 'la Separacion' : apply == 2 ? 'la Inicial' : apply == 3 ? 'la Financiacion' : 'el Total'
     }`
    );
    return setDeductions({ dto: maxDto, dtoFormat: maxDto * 100 + ' %', apply, [name]: saving });
   }

   return setDeductions({ dto, dtoFormat, apply, [name]: currency(value, true) });
  } else if (name === 'dto') {
   const [dto, dtoFormat] = percent(value);

   if (dto > maxDto && watch('notAdmin')) {
    const saving = currency(amount * maxDto, true);
    toast.info(
     `No es posible exceder el ${maxDto * 100 + '%'}de descuento maximo establecido en ${
      apply == 1 ? 'la Separacion' : apply == 2 ? 'la Inicial' : apply == 3 ? 'la Financiacion' : 'el Total'
     }`
    );
    return setDeductions({ saving, dtoFormat: maxDto * 100 + ' %', apply, [name]: maxDto });
   }

   const saving = currency(amount * dto, true);
   return setDeductions({ saving, dtoFormat, apply, [name]: dto });
  }

  if (deductions.dto > maxDto && watch('notAdmin')) {
   const saving = currency(amount * maxDto, true);
   toast.info(
    `No es posible exceder el ${maxDto * 100 + '%'}de descuento maximo establecido en ${
     apply == 1 ? 'la Separacion' : apply == 2 ? 'la Inicial' : apply == 3 ? 'la Financiacion' : 'el Total'
    }`
   );
   return setDeductions({ dto: maxDto, dtoFormat: maxDto * 100 + ' %', saving, [name]: value });
  }

  const saving = currency(amount * deductions.dto, true);
  return setDeductions({ ...deductions, saving, [name]: value });
 };

 const Savings = ({ keyCode }) => {
  const key = !keyCode ? 'a' : keyCode;
  if (deductions.apply > 0 && noCurrency(deductions.saving) > 0 && /13|27|a/.test(key))
   setValue('saving', noCurrency(deductions.saving));
  else setValue('saving', 0);
 };

 useEffect(() => {
  const [discounts, notAdmin, quote] = watch(['discounts', 'notAdmin', 'quote']);
  setOpen(!notAdmin || quote || discounts);
 }, [watch(['discounts', 'notAdmin', 'quote'])]);

 useEffect(() => {
  if (watch('notAdmin')) {
   setApply(discounts.some(e => e.isApply));
   const aply = discounts.some(e => e.isApply && e.apply == deductions.apply);
   Deductions({ target: { value: aply ? deductions.dtoFormat : 0, name: aply ? 'dto' : 'apply' } });
  }
 }, [discounts]);

 useEffect(() => {
  if (deductions.apply < 1 && deductions.dto > 0) {
   setValue('saving', 0);
   setDeductions({ ...deductions, dto: 0, dtoFormat: '0 %' });
  }
 }, [deductions]);

 return (
  <Card className="mb-3">
   <Card.Header className="">
    <Flex alignItems="center" wrap="wrap">
     <h6 className="fs-6 m-0 text-secondary">A</h6>
     <div className="flex-1">
      <h4 className="m-0 text-secondary">justes</h4>
      <p className="fs--2 m-0">Conoce al detalle cada producto de la orden</p>
     </div>
    </Flex>
    <Flex alignItems="center" wrap="wrap" justifyContent="end">
     <Card className="mb-auto" style={{ width: 460 }}>
      <InputGroup size="sm" className="rounded-3">
       <IconToggleButton
        icon="tags"
        className="m-0 d-none d-sm-block rounded-start"
        transform="shrink-2"
        iconAlign="middle"
        size="sm"
        id="discounts"
        name="discounts"
        type="checkbox"
        variant={apply ? 'success' : 'falcon-default'}
        checked={watch('discounts')}
        value={watch('discounts')}
        onChange={e => setValue('discounts', e.target.checked)}
       >
        <span className="d-none d-md-inline-block ms-1">Dto.</span>
       </IconToggleButton>
       <Form.Select
        aria-label="Aplicado"
        name="apply"
        value={deductions.apply}
        onChange={Deductions}
        disabled={watch('notAdmin') && !apply}
       >
        <option value={0}>Aplique en</option>
        {watch('notAdmin') ? (
         discounts
          .filter(e => e.isApply)
          .map(({ apply }, i) => (
           <option key={i} value={apply}>
            {{ 0: 'nada', 1: 'separacion', 2: 'inicial', 3: 'financiacion', 4: 'total' }[apply ?? 0]}
            {/* {apply == 1 ? 'Separacion' : apply == 2 ? 'Inicial' : apply == 3 ? 'Financiacion' : 'Total'} */}
           </option>
          ))
        ) : (
         <>
          <option value={1}>Separacion</option>
          <option value={2}>Inicial</option>
          <option value={3}>Financiacion</option>
          <option value={4}>Total</option>
         </>
        )}
       </Form.Select>
       <Form.Control
        type="text"
        aria-label="Porcentage de descuento"
        className="text-center"
        placeholder="0% Dto."
        name="dto"
        value={deductions.dtoFormat}
        onBlur={Savings}
        onKeyDown={Savings}
        onChange={Deductions}
        onFocus={({ target }) => target.select()}
        disabled={watch('notAdmin') && !apply}
       />
       <Form.Control
        type="text"
        aria-label="Ahorro en descuento"
        className="text-center w-25"
        placeholder="$ 0.0 Aho"
        name="saving"
        value={deductions.saving}
        onBlur={Savings}
        onKeyDown={Savings}
        onChange={Deductions}
        onFocus={({ target }) => target.select()}
        disabled={watch('notAdmin') && !apply}
       />
      </InputGroup>
     </Card>

     <IconToggleButton
      icon="tags"
      className="d-block d-sm-none ms-2 mt-3 mt-md-0"
      transform="shrink-2"
      iconAlign="middle"
      size="sm"
      id="discounts"
      name="discounts"
      type="checkbox"
      variant={apply ? 'success' : 'falcon-default'}
      checked={watch('discounts')}
      value={watch('discounts')}
      onChange={e => setValue('discounts', e.target.checked)}
     />

     <IconToggleButton
      icon="file"
      className="ms-2 mt-3 mt-md-0" // d-none d-sm-block
      transform="shrink-2"
      iconAlign="middle"
      size="sm"
      id="quote"
      name="quote"
      type="checkbox"
      variant="falcon-default"
      checked={watch('quote')}
      value={watch('quote')}
      onChange={e => setValue('quote', e.target.checked)}
      disabled={!watch('notAdmin')} // d-none d-md-inline-block
     >
      <span className="ms-1">Cotizar</span>
     </IconToggleButton>

     <IconToggleButton
      icon="file"
      className="ms-2 mt-3 mt-md-0" // d-none d-sm-block
      transform="shrink-2"
      iconAlign="middle"
      size="sm"
      id="notAdmin"
      name="notAdmin"
      type="checkbox"
      variant="falcon-default"
      checked={!watch('notAdmin')}
      value={!watch('notAdmin')}
      onChange={e => setValue('notAdmin', !e.target.checked)}
      disabled={watch('quote')}
     >
      <span className="ms-1">Propuesta</span>
     </IconToggleButton>
    </Flex>
   </Card.Header>
   <Collapse in={!!open}>
    <div className="border rounded">
     {watch('quote') && <Quote />}
     {!watch('notAdmin') && <Proposal />}
    </div>
   </Collapse>
   <Collapse in={watch('discounts')}>
    <div className="border rounded">{watch('discounts') && <Discounts discounts={discounts} />}</div>
   </Collapse>
  </Card>
 );
};

Discounts.propTypes = { discounts: PropTypes.array.isRequired };

Additional.propTypes = {
 watch: PropTypes.func.isRequired,
 setValue: PropTypes.func.isRequired,
 discounts: PropTypes.array.isRequired
};

export default Additional;
